import { render, staticRenderFns } from "./BillingForm.vue?vue&type=template&id=c64643a2&scoped=true"
import script from "./BillingForm.vue?vue&type=script&lang=js"
export * from "./BillingForm.vue?vue&type=script&lang=js"
import style0 from "./BillingForm.vue?vue&type=style&index=0&id=c64643a2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c64643a2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/workspace/Control-Panel/Control-Panel-Preprod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c64643a2')) {
      api.createRecord('c64643a2', component.options)
    } else {
      api.reload('c64643a2', component.options)
    }
    module.hot.accept("./BillingForm.vue?vue&type=template&id=c64643a2&scoped=true", function () {
      api.rerender('c64643a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PurchaseFlow/BillingForm.vue"
export default component.exports